import * as Constants from './constants'

export function ServerCallback() {
  return (req, res) => {
    res.writeHead(200)
    res.end(
      `<!DOCTYPE html><script type="text/javascript">window.top.postMessage({ type: "${Constants.IFRAME_CALLBACK_EVENT}" }, "*")</script>`
    )
  }
}
